import ItemService from '@/services/item-service.js';
import CategoryService from '@/services/category-service.js';
import PendingBidService from '@/services/pending-bid-service.js';
import types from './mutation-types';
import { isNil } from 'lodash';
import { CancelToken } from 'axios';

let autocompleteCategoryRequestSource = null;
const actions = {
	resetAll({ commit }) {
		commit(types.RESET_ALL);
	},
	resetLastCreatedItem({ commit }) {
		commit(types.RESET_LAST_CREATED_ITEM);
	},
	fetchItem({ commit }, itemId) {
		commit(types.FETCH_ITEM_START);

		return ItemService.getOne(itemId)
			.then(item => commit(types.FETCH_ITEM, item))
			.catch(error => commit(types.FETCH_ITEM_ERROR, error));
	},
	insertItem({ commit }, params) {
		commit(types.UPDATE_ITEM_START);

		return ItemService.insertOne(params.body)
			.then(item => {
				commit(types.LAST_CREATED_ITEM, item);
				commit(types.UPDATE_ITEM, item);
				return item;
			})
			.catch(error => commit(types.UPDATE_ITEM_ERROR, error));
	},
	moveItem({commit}, params) {
		commit(types.MOVE_ITEM_START);

		return ItemService.moveOne(params.itemId, params.body)
			.then(item => {
				commit(types.MOVE_ITEM, item);
				return item;
			})
			.catch(error => commit(types.MOVE_ITEM_ERROR, error));
	},
	updateItem({ commit }, params) {
		commit(types.UPDATE_ITEM_START);

		return ItemService.updateOne(params.itemId, params.body)
			.then(item => {
				commit(types.LAST_CREATED_ITEM, item);
				commit(types.UPDATE_ITEM, item);
				return item;
			})
			.catch(error => commit(types.UPDATE_ITEM_ERROR, error));
	},
	fetchPendingBids({ commit }, itemId) {
		commit(types.FETCH_PENDING_BIDS_START);

		return PendingBidService.getItemPendingBids(itemId, { total: 1000 })
			.then(data => commit(types.FETCH_PENDING_BIDS, {
				data: data.data,
				meta: {
					currentPage: data.current_page,
					total: data.total,
					perPage: parseInt(data.per_page),
					totalPages: Math.ceil(data.total / data.per_page)
				}
			}))
			.catch(error => commit(types.FETCH_PENDING_BIDS_ERROR, error));
	},
	fetchAutocompleteCategory({ commit }, query) {

		commit(types.FETCH_CATEGORY_AUTOCOMPLETE_START);

		if (!isNil(autocompleteCategoryRequestSource)) {
			autocompleteCategoryRequestSource.cancel();
		}

		autocompleteCategoryRequestSource = CancelToken.source();

		return CategoryService.get({ query: query }, autocompleteCategoryRequestSource.token)
			.then(categories => commit(types.FETCH_CATEGORY_AUTOCOMPLETE_SUCCESS, categories))
			.catch(error => commit(types.FETCH_CATEGORY_AUTOCOMPLETE_ERROR, error));
	},
	uploadMedia({ commit }, { id, media }) {
		commit(types.UPLOAD_MEDIA_START);

		return ItemService.uploadMedia(id, media)
			.then(media => commit(types.UPLOAD_MEDIA, media))
			.catch(error => commit(types.UPLOAD_MEDIA_ERROR, error));
	},
	deleteMedia({ commit }, { itemId, mediaId, mediaKey }) {

		commit(types.DELETE_MEDIA_START);

		return ItemService.deleteMedia(itemId, mediaId)
			.then(data => commit(types.DELETE_MEDIA_SUCCESS, mediaKey))
			.catch(error => commit(types.DELETE_MEDIA_ERROR, error));
	},
	updateItemSeller({ commit }, seller) {
		commit(types.UPDATE_SELLER, seller);
	},
};

export default actions;


// WEBPACK FOOTER //
// ./src/store/modules/item/actions.js